import { PeriodUnitType } from './subscription-period.model';
import { CalendarDay, toCalendarDay } from '@shared/models/models';

// Turn back into an interface to add UI-specific properties (e.g. readonly isNew?: boolean).
export type SubscriptionHighlight = SubscriptionHighlightDto;

export interface SubscriptionHighlightDto {
  id?: number;
  description: string;
  hasAccess: boolean;
  order?: number;
}

export interface SubscriptionDto {
  id: number;
  name: string;
  price: number;
  periodUnit: PeriodUnitType;
  periodValue: number;
  // Nullable `date` columns — calendar days, not instants, the same as UserSubscriptionDto's pair.
  // Normalised by withCalendarDays at every read boundary, so a reader here gets "2026-02-18" and
  // never the "2026-02-18T00:00:00" the API sends.
  startDate: CalendarDay | null;
  endDate: CalendarDay | null;
  description: string;
  externalId: string;
  accessItems: SubscriptionHighlightDto[];
}

export type CreateSubscriptionDto = Omit<SubscriptionDto, 'id'>;

/**
 * The read boundary for a subscription's two date columns.
 *
 * Lives here rather than on `SubscriptionsService` because two services read this DTO —
 * `SubscriptionsService.get` and `UserService.getSubscriptions` — and a day that is normalised on
 * only one of them is worse than one normalised on neither: the type would be true by coincidence.
 * There is no write counterpart; a `CalendarDay` is posted as-is.
 */
export function withSubscriptionCalendarDays(subscription: SubscriptionDto): SubscriptionDto {
  return {
    ...subscription,
    startDate: subscription.startDate ? toCalendarDay(subscription.startDate) : null,
    endDate: subscription.endDate ? toCalendarDay(subscription.endDate) : null,
  };
}
